import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startLoading, endLoading, startSending, endSending } from "../progress/pogressSlice";
import { closeModal } from "../modal/modalSlice";
import { serverErrors } from "..";
import * as api from '../../api'

const initialState = {
    currentPage: 0,
    rows: 0,
    size: 25,
    status: 'idle',
    staff: []
}

const dir = 'staff';

export const fetchStaff = createAsyncThunk('/staff/fetch', async (_, thunkAPI) => {
    thunkAPI.dispatch(startLoading())
    try {
        const { data } = await api.getPaginationData(dir);
        thunkAPI.dispatch(endLoading());
        return data
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue()
    }
})

export const loadNextPage = createAsyncThunk('/staff/nextPage', async({ page, size}, thunkAPI) => {
    thunkAPI.dispatch(startLoading())
    try {
        const { data } = await api.getPaginationData(dir, page, size);
        thunkAPI.dispatch(endLoading());
        return data
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endLoading))
        return thunkAPI.rejectWithValue()
    }
})

export const staffEvents = async(code, dispatch, setData, setStatus) => {
    dispatch(startLoading())
    try {
        const { data } = await api.getData(`${dir}/${code}`)
        dispatch(endLoading());
        setStatus('succeeded')
        return setData(data)
    } catch (error) {
        console.log(error);
        return dispatch(serverErrors(error, endLoading))
    }
}

export const createStaff = createAsyncThunk('/staff/create', async({ values, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending());
    try {
        const { data } = await api.createNew(dir, values);
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal());
        return data
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError));
        return thunkAPI.rejectWithValue()
    }
})

export const editStaff = createAsyncThunk('/staff/edit', async({ id, values, setError }, thunkAPI) => {
    thunkAPI.dispatch(startSending());
    try {
        const { data } = await api.editData(dir, id, values)
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal());
        return data
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending, setError));
        return thunkAPI.rejectWithValue()
    }
})

export const deleteStaff = createAsyncThunk('/staff/delete', async ({ id }, thunkAPI) => {
    thunkAPI.dispatch(startSending())
    try {
        await api.deleteItem(dir, id)
        thunkAPI.dispatch(endSending());
        thunkAPI.dispatch(closeModal());
        return id
    } catch (error) {
        console.log(error);
        thunkAPI.dispatch(serverErrors(error, endSending));
        return thunkAPI.rejectWithValue()
    }
})

export const staffSlice = createSlice({
    name: 'staff',
    initialState,
    reducers: {
        clearDetails: (state) => {
            state.details = { user: {}, report: [] }
        }
    },
    extraReducers(builder){
        builder
            .addCase(fetchStaff.fulfilled, (state, action) => {
                const { users, total, size, currentPage } = action.payload;
                state.currentPage = currentPage
                state.rows = total
                state.size = size
                state.status = 'succeeded'
                state.staff = users
            })
            .addCase(loadNextPage.fulfilled, (state, action) => {
                const { users, size, currentPage } = action.payload;
                state.currentPage = currentPage
                state.size = size
                state.staff = users
            })
            .addCase(createStaff.fulfilled, (state, action) => {
                state.rows = state.rows + 1
                state.staff = [ action.payload, ...state.staff]
            })
            .addCase(editStaff.fulfilled, (state, action) => {
                Object.keys(state.staff).forEach(function eachKey(key){
                    if(state.staff[key].id === action.payload.id)
                        return state.staff[key] = action.payload
                })
            })
            .addCase(deleteStaff.fulfilled, (state, action) => {
                state.rows = state.rows - 1
                state.staff = state.staff.filter(s => s.id !== action.payload)
            })
    }
})

export const { clearDetails } = staffSlice.actions;

export default staffSlice.reducer;